import { useMemo } from "react";
import type { Status } from "types/Status";

function useStatusBuilder(statuses: Status[]): Status {
  return useMemo(() => {
    if (statuses.includes("fetching")) return "fetching";
    if (statuses.includes("error")) return "error";
    return "success";
  }, [statuses]);
}

export default useStatusBuilder;
